const EditCourierPermission = () =>
  import(
    /* webpackChunkName: "courier-permission" */ '@/pages/courier/security/permission/courier/index.vue'
  )

const OperatorPermission = () =>
  import(
    /* webpackChunkName: "courier-operator" */ '@/pages/courier/security/permission/operator/index.vue'
  )

export default {
  path: 'security',
  meta: { label: 'security' },
  component: {
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'CompanyEditSecurityPermission',
      path: 'permission/:id',
      meta: { label: 'Edit' },
      component: EditCourierPermission,
      props: true
    },
    {
      name: 'OperatorSecurityPermission',
      path: 'operator/permission/:id',
      meta: { label: 'Edit' },
      component: OperatorPermission,
      props: true
    }
  ]
}
